import EntityType from "@/models/Shared/EntityType";

export default (value: EntityType) => {
   switch(value) {
       case EntityType.Organisation: {
           return "Organisation";
        }
        case EntityType.Person: {
            return "Person";
         }
         case EntityType.Product: {
            return "Product";
         }
         case EntityType.ProductIssue: {
            return "Product Issue";
         }
         case EntityType.Rate: {
            return "Rate";
         }
         case EntityType.RateSource: {
            return "Rate Source";
         }
         case EntityType.Account: {
            return "Account"; // Note: Keep this as a fallback, unsure if the backend has compatibility for splitting deposit/lending account entity types
         }
         case EntityType.DepositAccount: {
            return "Deposit Account";
         }
         case EntityType.LendingAccount: {
            return "Lending Account";
         }
         case EntityType.Region: {
            return "Region";
         }
         default: {
            return "Unknown entity type";
         }
   }
}